// extracted by mini-css-extract-plugin
export default {"title":"SelfRegistrationFormContentFields_title__p8dNR","submitButton":"SelfRegistrationFormContentFields_submitButton__+0pW0"};